#download-package-action-button {
  button {
    min-width: 140px;
  }
}

.action-icon {
  vertical-align: middle;
}

.action-icon {
  display: inline-block;

  &:before {
    font-size: 32px;
  }
}
